// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".8018e185f81d325d77f22aeade601ed4fb0d4513.chunk.js";
};